module.exports = __webpack_public_path__ + "static/ux-digital-marketers-812a9e69893da73e45800a4885753319.png";